import { useQuery } from "@tanstack/react-query";
import { discountService } from "..";

const useGetDiscountByCode = (code: string) =>
  useQuery({
    queryKey: ["getDiscountInfoByCode", code],
    queryFn: () => discountService.getDiscountByCode(code),
    select: (res) => res,
    enabled: false,
  });

export { useGetDiscountByCode };
